import { AxiosError } from 'axios';
import { lang } from 'src/utils';

export const improvedFailedToError = (action: string, resource: string) => {
  return (error: unknown) => {
    let errorMessage = '';
    if (error instanceof AxiosError) {
      errorMessage = error.response?.data?.error || error.message;
    }

    // TODO: update with improved error message from ts-utils
    if (errorMessage?.includes('unique field already exists')) {
      errorMessage = lang.errors.duplicatedName;
    }

    return lang.errors.failedTo(action, resource, errorMessage);
  };
};
